module.exports = __webpack_public_path__ + "static/media/play-store@2x.a4110fc7.png";